module.exports = wtr_shared_19_7_1;